import React from "react"
import clsx from "clsx"
import { AppLink } from "@ecom/ui/components/AppLink"
import * as styles from "./singleCard.module.scss"
import { ISingleCardProps, ImgComponent } from "../types"
import { CREDIT_CARDS_LIST, ZAIMY_CARDS_LIST, DEBET_CARDS_LIST } from "../data"
import { CreditCardImg, ZaimyCardImg, DebetCardImg } from "../img"

export const SingleCard = ({
  title,
  description,
  url,
  dataContent,
  index,
  variantStyles,
}: ISingleCardProps) => {
  let ImageVariant: ImgComponent
  const isHidden =
    (dataContent === CREDIT_CARDS_LIST && index! >= 5) ||
    (dataContent === DEBET_CARDS_LIST && index! >= 5)

  switch (dataContent) {
    case CREDIT_CARDS_LIST:
      ImageVariant = CreditCardImg
      break
    case ZAIMY_CARDS_LIST:
      ImageVariant = ZaimyCardImg
      break
    case DEBET_CARDS_LIST:
      ImageVariant = DebetCardImg
      break
    default:
      ImageVariant = CreditCardImg
      break
  }

  return (
    <div className={clsx(styles.card, variantStyles && styles[variantStyles])}>
      <div className={styles.adaptiveBlock}>
        <ImageVariant className={styles.img} alt="card" />
        <div className={styles.textBlock}>
          <div>
            <p className={styles.title}>{title}</p>
          </div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>

      <div className={styles.btnGroup}>
        <AppLink href={url} target="_blank" rel="noreferrer" className={styles.btnSecondary}>
          Подробнее
        </AppLink>
        {!isHidden && (
          <AppLink
            href={`${url}${"#app"}`}
            target="_blank"
            rel="noreferrer"
            className={styles.btnPrimary}
          >
            Оформить
          </AppLink>
        )}
      </div>
    </div>
  )
}
